import React, { useEffect } from 'react'
import { ekincare_full_logo } from '../../assets/images'
import { LeftPanel } from '../common/templates/Login';
import MFAMethod from '../common/templates/Login/MFAMethod';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { appApi } from '../../services';
import { message } from 'antd';

function MFAMethodPage() {
  const history = useHistory()

  useEffect(() => {
    let mfa_token = sessionStorage.getItem('mfa_token')
    if(!mfa_token) history.push('/login')
  },[])

  const methodSelected =  (e, type) => {
    if(type === 'app') fetchAuth('mfaQRCode', 'mfa-qr')
    else  fetchAuth('mfaOTPCode', 'mfa-otp')
  }

  const fetchAuth = async (method, pathname) => {
    let mfa_token = sessionStorage.getItem('mfa_token')
    let options = { data: {mfa_token: mfa_token}}
    
    await appApi[method](options,
      (res)=>{
          history.push({pathname: pathname, state: res.data})
      },
      _=>{
        message.error('Something went wrong!')
      }
      );
  }

  return (
    <div className='flex min-h-screen'>
      <LeftPanel />
      <div className='w-2/5 pt-16 pl-24 bg-white'>
        <img src={ekincare_full_logo} alt='ekincare_logo' />
        <div className='mt-12'>
          <MFAMethod  methodSelect={methodSelected} history={history} />
        </div>
      </div>
    </div>  
  )
}

export default MFAMethodPage